import { render, staticRenderFns } from "./homecare.vue?vue&type=template&id=400acfa4&scoped=true"
import script from "./homecare.vue?vue&type=script&lang=js"
export * from "./homecare.vue?vue&type=script&lang=js"
import style0 from "./homecare.vue?vue&type=style&index=0&id=400acfa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400acfa4",
  null
  
)

export default component.exports